/**
 * Work-order lifecycle statuses ("job_work_order_status.name") that mean the
 * job is actively being worked and could change without operator action.
 * Scoped narrowly to CWL-386's named examples — En Route / On Site — so this
 * cannot become the "unconditional background polling of full lists" the
 * ticket's AC forbids.
 */
export const IN_FLIGHT_WORK_ORDER_STATUSES = new Set(['En Route', 'On Site']);

export function isInFlightWorkOrderStatus(status: string | null | undefined): boolean {
  return status != null && IN_FLIGHT_WORK_ORDER_STATUSES.has(status);
}
